var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Skeleton',[_c('SkeletonItem',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"update-billing-period-skel__box rm-m--12"}),_c('div',{staticClass:"update-billing-period-skel__box rm-m--12"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }